// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".cascading-select[data-v-2584f6fb]{margin-bottom:10px;width:100%}.c-title[data-v-2584f6fb]{font-size:14px;font-weight:600;color:#323130;padding:5px 0}.select-container[data-v-2584f6fb]{display:flex;align-items:center;flex-wrap:wrap;gap:8px}.separator[data-v-2584f6fb]{font-size:16px;color:#909399;padding:0 5px}@media(max-width:768px){.select-container[data-v-2584f6fb]{flex-direction:column;align-items:flex-start}.separator[data-v-2584f6fb]{display:none}}", ""]);
// Exports
module.exports = exports;
